import { c as _c } from "react/compiler-runtime";
import { motion } from 'motion/react';
import { memo, type ReactNode } from 'react';
import { getCardNetApyConfig } from '../CardNetApy.config';
const CardAnimationWrapper = t0 => {
  const $ = _c(12);
  const {
    children,
    isExpanded,
    isSmall
  } = t0;
  let t1;
  if ($[0] !== isExpanded || $[1] !== isSmall) {
    t1 = getCardNetApyConfig(isSmall, isExpanded);
    $[0] = isExpanded;
    $[1] = isSmall;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    width
  } = t1;
  let t2;
  if ($[3] !== width) {
    t2 = {
      width,
      height: "100%",
      z: 0
    };
    $[3] = width;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.2,
      height: {
        duration: 0.6
      }
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== width) {
    t4 = {
      width,
      height: "100%",
      flexShrink: 0
    };
    $[6] = width;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== children || $[9] !== t2 || $[10] !== t4) {
    t5 = <motion.div key="card-net-apy-wrapper" animate={t2} initial={false} transition={t3} style={t4}>{children}</motion.div>;
    $[8] = children;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default memo(CardAnimationWrapper);